import customAxios from "../../customAxios";
import { DELETE_DRIVER } from "../../routes";

const deleteDriver = async (driverId: string) => {
  try {
    return (await customAxios.delete(DELETE_DRIVER + `/${driverId}`)).data;
  } catch (error: any) {
    console.log({ DELETE_DRIVER: error });
    return false;
  }
};

export default deleteDriver;
